export enum PostingSort {
  RoomNumber = 'roomNumber',
  HousekeepingStatus = 'housekeepingStatus'
}



// WEBPACK FOOTER //
// ./src/components/Posting/Dashboard/enum/postingSort.ts